import React from "react";
import { DropdownV2, InputV2 } from "../../../FormControlsV2";
import { ProductIncomingTaskFiltersProps } from "./types";
import { useTranslation } from "react-i18next";

export function ProductIncomingTaskFilters({
  farmOptions,
  currentFarm,
  onFarmChange,
  farmLabel,
  allResponsibles,
  currentResponsible,
  onResponsibleChange,
}: ProductIncomingTaskFiltersProps) {
  const { t } = useTranslation();
  return (
    <div className="filters-container filters-wrap">
      <div className="filters-dropdown">
        <DropdownV2
          name="create-task-farm"
          label={t("taskCreation.farm")}
          placeholder={t("taskCreation.selectFarm")}
          options={farmOptions}
          value={currentFarm ?? null}
          menuMount="overlay"
          onChange={(opt) => onFarmChange(opt?.value)}
        />
      </div>
      <div className="filters-dropdown">
        <InputV2
          name="create-task-deposit"
          label={t("taskCreation.deposit")}
          value={t("taskCreation.centralStorage")}
          disabled
        />
      </div>
      <div className="filters-dropdown filters-dropdown__full-width">
        <DropdownV2
          name="create-task-responsible"
          label={t("taskCreation.responsible")}
          placeholder={t("taskCreation.selectIncomingResponsible")}
          options={allResponsibles}
          value={currentResponsible ?? null}
          menuMount="overlay"
          onChange={(opt) => onResponsibleChange(opt)}
        />
      </div>
    </div>
  );
}
